export type SalesDeskLocationOption = {
  id: string;
  label: string;
};

export type SalesDeskStockDestination = {
  id: string | null;
  label: string;
};

export type SalesDeskStockSource = {
  id: string;
  model: string;
  serial: string | null;
};

export type SalesDeskStockDraft = {
  sourceSaleId: string;
  sourceLabel: string;
  sourceSerial: string | null;
  destinationLocationId: string | null;
  destinationLabel: string;
  size: string;
  color: string;
  electrical: string;
  evidenceIds: string[];
};

export type SalesDeskStockRequest = SalesDeskStockDraft & {
  id: string;
  status: "not_sent";
};

export function salesDeskStockDestination(
  locations: SalesDeskLocationOption[],
  activeLocationId: string | null,
  fallbackLabel: string,
): SalesDeskStockDestination {
  const match = locations.find((location) => location.id === activeLocationId) ?? locations[0];
  if (match) return { id: match.id, label: match.label };
  return { id: null, label: fallbackLabel.trim() };
}

export function salesDeskSizePrefill(model: string, serial: string | null): string {
  const match = `${model} ${serial ?? ""}`.match(/(\d{1,2})\s*x\s*(\d{1,2})/i);
  return match ? `${match[1]}x${match[2]}` : "";
}

export function salesDeskStockDraftFromSale(
  sale: SalesDeskStockSource,
  destination: SalesDeskStockDestination,
  evidenceIds: string[],
): SalesDeskStockDraft {
  const serial = sale.serial?.trim() || null;
  const model = sale.model.trim();
  return {
    sourceSaleId: sale.id,
    sourceLabel: model || serial || `Sale ${sale.id.slice(0, 8)}`,
    sourceSerial: serial,
    destinationLocationId: destination.id,
    destinationLabel: destination.label.trim(),
    size: salesDeskSizePrefill(model, serial),
    color: "",
    electrical: "",
    evidenceIds: [...evidenceIds],
  };
}

export function submitSalesDeskStockDraft(
  draft: SalesDeskStockDraft,
  existing: SalesDeskStockRequest[],
  attachEvidence: boolean,
): { ok: true; request: SalesDeskStockRequest } | { ok: false; reason: "destination" } {
  const destinationLabel = draft.destinationLabel.trim();
  if (!destinationLabel) return { ok: false, reason: "destination" };
  return {
    ok: true,
    request: {
      ...draft,
      destinationLabel,
      size: draft.size.trim(),
      color: draft.color.trim(),
      electrical: draft.electrical.trim(),
      evidenceIds: attachEvidence ? [...draft.evidenceIds] : [],
      id: `STOCK-${existing.length + 1}`,
      status: "not_sent",
    },
  };
}
